module.exports = "/assets/images/38a0c8b387e16d47d9d13995695ad77b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_inprogress.svg
// module id = S/Bu
// module chunks = 0